/**
 * Created by mykurisu on 2017/8/8.
 */
import React from 'react'
import Config from '../../config'
import '../../styles/search/SearchPage.css'

class SearchDetailLiveroomItem extends React.Component {

    renderLink() {
        const {liveroom} = this.props;
        if (/lycheer/.test(navigator.userAgent.toLocaleLowerCase())){
            return `lizhiweike://liveroom?liveroom_id=${liveroom.id}`
        }else {
            return `/liveroom/${liveroom.id}`
        }
    }

    render() {
        const {liveroom} = this.props;
        return (
        <a href={this.renderLink()}>
            <div className="search-detail-page-liveroom search-detail-page-liveroom-border">
                <div className="search-detail-page-liveroom-left">
                    <div className="search-detail-page-liveroom-left_icon">
                        <div className="liveroom-slidetop-content-main-type">
                            {
                                liveroom.verify_type === 2 &&
                                <i className="iconfont verify-type-icon icon-yfv">
                                </i>
                            }
                            {
                                liveroom.verify_type === 1 &&
                                <i className="iconfont verify-type-icon verify-type-icon-special icon-yfv">
                                </i>
                            }
                        </div>
                        <div className="search-detail-page-liveroom-left_img">
                            <img src={liveroom.small_avatar_url} alt=""/>
                        </div>
                    </div>
                </div>
                <div className="search-detail-page-liveroom-right">
                    <p className="search-detail-page-liveroom-right_name">
                        {liveroom.name}
                    </p>
                    <p className="search-detail-page-liveroom-right_count">
                        {liveroom.fans_count}<span>人关注</span>
                    </p>
                    <p className="search-detail-page-liveroom-right_intro">
                        {liveroom.description}
                    </p>
                </div>
            </div>
        </a>
        )
    }
}

export default SearchDetailLiveroomItem


// WEBPACK FOOTER //
// ./src/components/search/SearchDetailLiveroomItem.js